import React from 'react'
import agent from '../agent'
import ChatChannelList from './widgets/ChatChannelList';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import {
    CHAT_CHANNEL_LIST_PAGE_LOADED,
    CHAT_CHANNEL_LIST_PAGE_UNLOADED,
} from '../constants/actionTypes'

const mapStateToProps = state => ({
    ...state.chat,
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) =>
        dispatch({ type: CHAT_CHANNEL_LIST_PAGE_LOADED, payload }),
    onUnload: () =>
        dispatch({ type: CHAT_CHANNEL_LIST_PAGE_UNLOADED })
});

class Channels extends React.Component {
    constructor() {
        super()
    }
    componentWillMount() {

        const payload = agent.Chats.chatList()
        this.props.onLoad(payload);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }
    render() {
        return (
            <div class='pane'>
                <Link className="buttonTop" to='/channels/create'><i className="icon ion-android-add-circle"></i></Link>
                <h1>Chat Channels List</h1>
                <ChatChannelList channels={this.props.channels} loading={this.props.loading} />
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Channels);



// WEBPACK FOOTER //
// ./src/components/Channels.js